export default __webpack_public_path__ + "static/subset-UniNeueLight-e36a12be5261912261fa7c440f24a8aa.woff2";